var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    { attrs: { name: "please-login", width: 0, "click-to-close": false } },
    [
      _c(
        "div",
        { staticClass: "modal show modal__please_login modal__new_design" },
        [
          _c("section", [
            _c("a", { staticClass: "modal__close" }, [
              _c("i", { staticClass: "icon-close", on: { click: _vm.hide } })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal__head text__bold text__center" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("MODAL.PLEASE_LOGIN_TITLE")) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _vm.showAuthBtn
              ? _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn__l btn__round btn__bordered",
                      on: {
                        click: function($event) {
                          return _vm.showJoin()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("BUTTON.JOIN")) +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn__l btn__round",
                      on: {
                        click: function($event) {
                          return _vm.showLogin()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("BUTTON.LOGIN")) +
                          "\n                "
                      )
                    ]
                  )
                ])
              : _vm._e()
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }